import { Store } from '../codegen/graphql';

function getLiveStoresWithCostPrice(stores: Store[]): Store[] {
    return stores.filter(
        store =>
            store?.productAvailability?.isLive &&
            store?.productAvailability?.costPrice != null,
    );
}

function maxCostPrice(stores: Store[]): number | null {
    const costPrices = stores
        .map(store => store.productAvailability?.costPrice)
        .filter(
            (price): price is number => price !== null && price !== undefined,
        );

    if (costPrices.length === 0) {
        return null;
    }

    return Math.max(...costPrices);
}

export function getHighestCostPrice(
    advertisingZoneStores: Store[],
): number | null {
    const liveStores = getLiveStoresWithCostPrice(advertisingZoneStores);
    return maxCostPrice(liveStores);
}

export function getHighestCashbuildCostPrice(
    advertisingZoneStores: Store[],
): number | null {
    const liveStores = getLiveStoresWithCostPrice(advertisingZoneStores).filter(
        store => !store.storeNo?.startsWith('P') || store.isTradingAsCashbuild,
    );
    return maxCostPrice(liveStores);
}

export function getHighestPnlCostPrice(
    advertisingZoneStores: Store[],
): number | null {
    const liveStores = getLiveStoresWithCostPrice(advertisingZoneStores).filter(
        store => store.storeNo?.startsWith('P') && !store.isTradingAsCashbuild,
    );
    return maxCostPrice(liveStores);
}
